export default __webpack_public_path__ + "static/media/vin.47d0606b.svg";